var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("SeaExport.MscBlAddress"),
        "close-on-click-modal": false,
        width: "768px"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          attrs: {
            "label-width": "165px",
            inline: "",
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "marginLeft",
              attrs: { label: _vm.$t("SeaExport.CompanyName") }
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.form.companyName,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "companyName", $$v)
                  },
                  expression: "form.companyName"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "marginLeft",
              attrs: { label: _vm.$t("SeaExport.VipCode") }
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.form.vipCode,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "vipCode", $$v)
                  },
                  expression: "form.vipCode"
                }
              })
            ],
            1
          ),
          _c("br"),
          _c(
            "el-form-item",
            {
              staticClass: "marginLeft",
              attrs: { label: _vm.$t("SeaExport.GroupCode") }
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.form.groupCode,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "groupCode", $$v)
                  },
                  expression: "form.groupCode"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "marginLeft",
              attrs: { label: _vm.$t("SeaExport.MscCode") }
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.form.mscCode,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "mscCode", $$v)
                  },
                  expression: "form.mscCode"
                }
              })
            ],
            1
          ),
          _c("br"),
          _c(
            "el-form-item",
            {
              staticClass: "marginLeft",
              attrs: { label: _vm.$t("SeaExport.CompanyAddress") }
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.form.companyAddress,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "companyAddress", $$v)
                  },
                  expression: "form.companyAddress"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "marginLeft",
              attrs: { label: _vm.$t("SeaExport.InttraCode") }
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.form.inttraCode,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "inttraCode", $$v)
                  },
                  expression: "form.inttraCode"
                }
              })
            ],
            1
          ),
          _c("br"),
          _c(
            "el-form-item",
            {
              staticClass: "marginLeft",
              attrs: { label: _vm.$t("SeaExport.City") }
            },
            [
              _c("el-input", {
                ref: "cityNameInput",
                on: { focus: _vm.cityClickHandler },
                model: {
                  value: _vm.form.cityName,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "cityName", $$v)
                  },
                  expression: "form.cityName"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "marginLeft",
              attrs: { label: _vm.$t("SeaExport.OtherInformation") }
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.form.otherInformation,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "otherInformation", $$v)
                  },
                  expression: "form.otherInformation"
                }
              })
            ],
            1
          ),
          _c("br"),
          _c(
            "el-form-item",
            {
              staticClass: "marginLeft",
              attrs: { label: _vm.$t("SeaExport.ZipCode") }
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.form.zipCode,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "zipCode", $$v)
                  },
                  expression: "form.zipCode"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "marginLeft",
              attrs: { label: _vm.$t("SeaExport.BlTitle") }
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.form.blTitle,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "blTitle", $$v)
                  },
                  expression: "form.blTitle"
                }
              })
            ],
            1
          ),
          _c("br"),
          _c(
            "el-form-item",
            {
              staticClass: "marginLeft",
              attrs: { label: _vm.$t("SeaExport.Contact") }
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.form.contact,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "contact", $$v)
                  },
                  expression: "form.contact"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "marginLeft",
              attrs: { label: _vm.$t("SeaExport.BlAddress") }
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.form.blAddress,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "blAddress", $$v)
                  },
                  expression: "form.blAddress"
                }
              })
            ],
            1
          ),
          _c("br"),
          _c(
            "el-form-item",
            {
              staticClass: "marginLeft",
              attrs: { label: _vm.$t("SeaExport.Tel") }
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.form.phone,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "phone", $$v)
                  },
                  expression: "form.phone"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "marginLeft",
              attrs: { label: _vm.$t("SeaExport.BlContact") }
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.form.blContact,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "blContact", $$v)
                  },
                  expression: "form.blContact"
                }
              })
            ],
            1
          ),
          _c("br"),
          _c(
            "el-form-item",
            {
              staticClass: "marginLeft",
              attrs: { label: _vm.$t("SeaExport.Fax") }
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.form.fax,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "fax", $$v)
                  },
                  expression: "form.fax"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: { "text-align": "center" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.saveHandler } },
            [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
          ),
          _c("el-button", { on: { click: _vm.closeHandler } }, [
            _vm._v(_vm._s(_vm.$t("common.btn.close")))
          ])
        ],
        1
      ),
      _c("location-search-dialog", {
        attrs: { visible: _vm.cityDialogVisible },
        on: {
          "update:visible": function($event) {
            _vm.cityDialogVisible = $event
          },
          addCallBack: _vm.selectLocalHandler,
          close: function($event) {
            _vm.cityDialogVisible = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }